__turbopack_context__.v({
  "icon": "SidebarLayout-module__Zs2NTa__icon",
  "layout": "SidebarLayout-module__Zs2NTa__layout",
  "mainContent": "SidebarLayout-module__Zs2NTa__mainContent",
  "nav": "SidebarLayout-module__Zs2NTa__nav",
  "navItem": "SidebarLayout-module__Zs2NTa__navItem",
  "sidebar": "SidebarLayout-module__Zs2NTa__sidebar",
});
